<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-row no-gutters>
        <v-col cols="12">
          <input
            id="login_email"
            ref="login_email"
            type="text"
            autocomplete="email"
            autocapitalize="email"
            class="text_field_login w-input"
            :class="{
                  'autofill-fix-dark': $vuetify.theme.dark,
                  'autofill-fix': !$vuetify.theme.dark,
                  'mb-0': emailErrors.length,
                }"
            :placeholder="$t('email')"
            v-model="inputEmail"
            @keydown.space.prevent
          />
        </v-col>

        <v-col cols="12">
          <p v-if="emailErrors.length" class="mb-0 ml-1 darkRed--text">
            {{ emailErrors[0] }}
          </p>
        </v-col>

        <v-col cols="12">
          <password
            :placeholder="$t('password')"
            id="login_password"
            v-model="password"
            :errors="passwordErrors"
          />
        </v-col>

        <v-col cols="12">
          <v-row justify="center">
            <vue-recaptcha
              v-if="showRecaptcha"
              ref="recaptcha"
              class="pt-3 pb-2"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              :language="locale"
              :loadRecaptchaScript="true"
              :theme="$vuetify.theme.dark ? 'dark' : 'light'"
              :sitekey="recaptchaSiteKey"
            />
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-sign"
            :loading="loading"
            type="submit"
            color="secondary"
          >
            {{ $tc("access_the_platform") }}
          </v-btn>
        </v-col>

        <v-col class="mt-5" cols="12">
          <span class="lc-memo">{{ $tc("dont_have_a_account") }}</span> <a id="sign-up-now"
                                                                           @click="$router.push({ name: 'join'})">{{
            $tc("sign_up_now")
          }}</a>
        </v-col>

        <v-col class="mt-5" cols="12">
          <a @click="forgotPwd">{{ $tc("forgot_pwd") }}</a>
        </v-col>

      </v-row>
    </v-form>
    <slot name="bottom"/>
    <tfa-modal :open="showTFAModal" @close="closeModal"/>
  </div>
</template>
<script>
import Password from '@/components/fields/Password'
import {required} from "vuelidate/lib/validators";
import TfaModal from "../modals/TFAModal";
import VueRecaptcha from "vue-recaptcha";

export default {
  data() {
    return {
      showTFAModal: false,
      loading: false,
      password: "",
      email: "",
      showPassword: false,
    };
  },
  components: {VueRecaptcha, TfaModal, Password},
  computed: {
    inputEmail: {
      get() {
        return this.email;
      },
      set() {
        this.setInputValue(...this.getInputValue().map(this.stripSpaces));
      },
    },
    recaptchaToken: {
      get() {
        return this.$store.state.auth.recaptchaToken;
      },
      set(val) {
        return this.$store.commit("auth/SET_USER_RECAPTCHA", val);
      },
    },
    locale() {
      return this.$store.state.locale.locale;
    },
    recaptchaSiteKey() {
      return this.$store.state.ui.recaptchaSiteKey;
    },
    showRecaptcha() {
      return this.$store.getters["ui/GET_NEEDS_RECATCHA_LOGIN"];
    },
    // ERRORS
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push(this.$t("$validation.required"));
      !this.$v.email.validEmail &&
      errors.push(this.$t("$validation.invalid_email"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
      errors.push(this.$t("$validation.required"));
      return errors;
    },
  },
  validations() {
    const validations = {};

    const validEmail = (value) => {
      if (!value) return true;
      let expression = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return expression.test(value);
    };
    (validations.email = {
      required,
      validEmail,
    }),
      (validations.password = {
        required,
      });
    return validations;
  },
  methods: {
    getInputValue() {
      const input = this.$refs.login_email;
      const value = input.value;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      return [value.slice(0, start), value.slice(start, end), value.slice(end)];
    },
    setInputValue(before, selection, after) {
      const input = this.$refs.login_email;
      const start = before.length;
      const end = start + selection.length;

      const value = (input.value = before + selection + after);

      input.setSelectionRange(start, end);

      this.email = value;

      this.$emit("input", value);
    },
    stripSpaces(str) {
      return str.replace(/ /g, "");
    },
    closeModal() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("refresh_token");
      this.showTFAModal = false;
    },
    clearRecaptcha() {
      this.$refs.recaptcha.reset();
    },
    async submit() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      if (
        (isValid && !this.showRecaptcha) ||
        (isValid && this.recaptchaToken !== null)
      ) {
        if (this.showRecaptcha) this.clearRecaptcha();
        this.doLogin();
      }
    },
    doLogin() {
      this.loading = true
      this.$store
        .dispatch('auth/doLogin', {
          body: { email: this.email, password: this.password },
        })
        .then(({ refresh_token, token, detail, message }) => {
          this.error = null
          // this.$store.dispatch("auth/startProdTools", { root: true });
          if (token && refresh_token) {
            this.$store
              .dispatch('account/doGetUserInfo')
              .then(({ tfa, lang }) => {
                this.$store.commit('auth/SET_STATE', {
                  token,
                  refresh_token,
                  isLogged: tfa === undefined || tfa === true,
                })
                if (tfa === undefined || tfa === true) {
                  this.$router.push({ name: 'home' })
                } else {
                  this.showTFAModal = true
                }
                this.$store.commit('locale/SET_LOCALE', lang)
              })
          } else {
            this.$notify.error(detail || message || 'Error')
          }
        })
        .catch((error) => {
          this.$store.commit('auth/SET_STATE', { email: this.email })
        })
        .finally(() => {
          this.loading = false
          this.$v.$reset()
        })
    },
    onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    forgotPwd() {
      this.$router.push({name: "forgot-password"});
    },
  },
};
</script>

<style>

#btn-sign {
  border-radius: 11px;
  text-transform: initial;
  font-weight: 600;
}

#showPassword {
  color: var(--v-primary-base);
  top: -47px;
  right: 0;
  float: right;
}

#sign-up-now {
  color: var(--v-accent-darken1);
  font-weight: 600;
  text-decoration: underline;
}

.lc-memo {
  color: var(--v-secondary-lighten2);
}

</style>